<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import { useGetSearchResults } from '@/api'
import { SearchCombobox } from '@/components/search'
import { PATIENTS_PATH } from '@/constants'
import { Icon, Button, Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/ui'

const router = useRouter()

const { getSearchResults } = useGetSearchResults()
const search = ref('')

const { responseData, isFetching, execute } = getSearchResults(search)

const debouncedSearch = useDebounceFn(() => {
  execute()
}, 500)

watch(search, value => {
  if (value.length > 2) debouncedSearch()
})

const onSelect = (id: string) => {
  search.value = ''
  router.push(`${PATIENTS_PATH}/${id}`)
}
</script>

<template>
  <SearchCombobox
    v-model:search-value="search"
    :options="responseData"
    :is-fetching="isFetching"
    class="hidden md:block"
    input-class-names="h-10"
    @select="onSelect"
  />
  <Sheet>
    <SheetTrigger class="md:hidden" as-child>
      <Button variant="ghost" size="icon">
        <Icon name="MagnifyingGlassIcon" class="size-5" />
        <span class="sr-only">Open search</span>
      </Button>
    </SheetTrigger>
    <SheetContent class="w-[400px] sm:w-[540px]">
      <SheetHeader class="mb-4">
        <SheetTitle class="text-left">Search</SheetTitle>
      </SheetHeader>
      <SearchCombobox
        v-model:search-value="search"
        :options="responseData"
        :is-fetching="isFetching"
        class="-mx-1"
        input-class-names="h-12"
        @select="onSelect"
      />
    </SheetContent>
  </Sheet>
</template>
